import * as Yup from 'yup';

export const dataModel = {
  code: '',
  name: '',
  varietyUuid: '',
  active: '',
};

export const validationDataModel = Yup.object().shape({
  code: Yup.string().optional(''),
  name: Yup.string().optional(''),
  varietyUuid: Yup.string().optional(''),
  active: Yup.boolean().optional(''),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
